import React from "react";
import style from "../../assets/css/global-fields.module.scss";
import fillCircle from "../../assets/img/proposal-img/btn-circle-active.svg";
import emptyCircle from "../../assets/img/proposal-img/btn-circle.svg";
import GlobalErrorMsgBox from "./GlobalErrorMsgBox";

// const GlobalRadio = ({ title,selected }) => {
//   // const [selected, setSelected] = useState(false);

//   return (
//     <>
//       <button
//         className={`${style.global_radio} ${selected ? style.globalRadioActive : null}`}
//         // onClick={() => setSelected(!selected)}
//       >
//         {selected ? <img src={fillCircle} /> : <img src={emptyCircle} />}
//         {title}
//       </button>
//     </>
//   );
// };
const GlobalRadio = ({title, selected, onClick, error, errorText}) => {
  return (
    <div className={style.GlobalRadioBtn}>
      <button
        className={`${style.global_radio} ${selected ? style.globalRadioActive : null}`}
        onClick={onClick}
        type="button"
      >
        {selected ? (
          <img src={fillCircle} alt="Selected" />
        ) : (
          <img src={emptyCircle} alt="Not Selected" />
        )}
        {title}
      </button>

      {error ? <GlobalErrorMsgBox errMessage={errorText} /> : null}
    </div>
  );
};

export default GlobalRadio;
